import { z } from "zod"

import {
  correlationIdSchema,
  entityIdSchema,
  legalEntityIdSchema,
  tenantIdSchema,
} from "./identifiers.js"

export const payrollActivationStateV1Schema = z.enum([
  "not_enabled",
  "provisioning",
  "action_required",
  "active",
  "suspended",
])

export const payrollAddonProjectionV1Schema = z.object({
  tenantId: tenantIdSchema,
  state: payrollActivationStateV1Schema,
  version: z.number().int().positive(),
  source: z.literal("platform_entitlement_projection"),
}).strict()

export const payrollActivationTransitionV1Schema = z.object({
  requestVersion: z.literal(1),
  correlationId: correlationIdSchema,
  idempotencyKey: z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/),
  expectedVersion: z.number().int().nonnegative(),
  activationId: entityIdSchema,
  transitionId: entityIdSchema,
  legalEntityId: legalEntityIdSchema,
  targetState: payrollActivationStateV1Schema,
  reasonCode: z.enum([
    "tenant_admin_requested",
    "provider_provisioning",
    "configuration_required",
    "provider_ready",
    "subscription_suspended",
    "reactivation_requested",
  ]),
}).strict()

export const payrollActivationResultV1Schema = z.object({
  entityType: z.literal("payroll_activation"),
  entityId: entityIdSchema,
  legalEntityId: legalEntityIdSchema,
  state: payrollActivationStateV1Schema,
  version: z.number().int().positive(),
  subscriptionState: payrollActivationStateV1Schema,
  coreOperationsAvailable: z.literal(true),
}).strict()

export type PayrollActivationStateV1 = z.infer<
  typeof payrollActivationStateV1Schema
>
export type PayrollAddonProjectionV1 = z.infer<
  typeof payrollAddonProjectionV1Schema
>
export type PayrollActivationTransitionV1 = z.infer<
  typeof payrollActivationTransitionV1Schema
>
export type PayrollActivationResultV1 = z.infer<
  typeof payrollActivationResultV1Schema
>
